import { IActiveTier, IListItem } from '../../list-page/interfaces/interfaces';
import { getSubscriptionActiveTiers } from '../../list-page/services/list-page-provider';
import { useState } from 'react';

interface IProductSubscriptionTiers {
    product: IListItem,
    isGrid: boolean,
    classEx?: string,
}

const sbsActiveTiers = getSubscriptionActiveTiers();

/**
 * when SBSIncludedIn=1 , print just the name of ItemOrder 1 from json.
 * when SBSIncludedIn=2, print both 2 and 1, in descending order: Included in: 2 1.
 */
const getTiers = (sbsIncludedIn: number) => {
    const tiers: IActiveTier[] = [];

    for(let i=sbsIncludedIn - 1; i>=0; i--){
        tiers.push(sbsActiveTiers[i]);
    }

    return tiers;
};

const ProductSubscriptionTiers = (props: IProductSubscriptionTiers) => {
    const { product, isGrid } = props;
    const [ tiers ] = useState(getTiers(product.sbsIncludedIn ?? 1));

    const basicClassName = `sbs-included-in ${ (isGrid ? `flex flex-wrap flex-1 items-center ` : `flex flex-col flex-1 `) }`;
    const className = basicClassName + (typeof props.classEx !== 'undefined' && props.classEx !== null ? props.classEx  : '');

    return (
        <div className={ className }>
            <span className="text-sm leading-8 mr-2">Included in</span>
            <div className="flex items-center">
                {
                    tiers.map(tier => {
                        return (
                            <div key={ tier.tierName } className="text-xs bg-gray-100 mr-2 border rounded px-2 py-1 line-height-normal">{ tier.tierName }</div>
                        )
                    })
                }
            </div>
        </div>
    )
};

export default ProductSubscriptionTiers;